<template>
  <div>
    <vs-popup :title="$t('ShowSubmitBarcode')" :active.sync="showModal">
      <div class="vx-row">
        <div class="vx-col w-full mb-base">
          <data-grid
            ref="grid"
            stripe
            :data-source="gridDataSource"
            :search-data="gridSearchData"
            :columns="[{ title: $t('Serial') }]"
          >
            <template slot-scope="{ row }">
              <td style="width: 80%">
                {{ row.serial }}
              </td>
            </template>
          </data-grid>
        </div>
      </div>
    </vs-popup>
  </div>
</template>
<style lang="scss">
.vs-con-input input {
  text-align: right;
}
.custom-tbl td {
  padding: 0.5rem 1rem !important;
}
</style>
<script>
import DataGrid from "@/components/datagrid/DataGrid";
export default {
  name: "",
  props: {
    show: { default: false },
    countGroupId: { default: "" },
    countTagId: { default: "" },
  },
  components: {
    DataGrid,
  },
  data() {
    return {
      isShowIncrease: false,
      manualUrlService: "",
      gridDataSource: { data: [] },
      gridSearchData: {},
    };
  },

  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {},
  watch: {
    show() {
      if (this.show) {
        this.manualUrlService =
          "Inventory/api/CountingTagQuery/" +
          this.countTagId +
          "/groups/" +
          this.countGroupId +
          "/inventory-items";
        this.gridDataSource = { type: "app", service: this.manualUrlService };
        setTimeout(() => {
          this.$refs.grid.renderGrid();
        }, 150);
      }
    },
  },
};
</script>
